import React from 'react';
import OrderTrackingDataGrid from './OrderTrackingDataGrid';

const OrderTrackingPage = ({ orderTrackingInfo }) => {

    if (!orderTrackingInfo) {
        console.log('In Order Tracking Page with no data')
        return <div>No data available</div>;
    }
    else
        console.log('In Order Tracking Page with data: ', orderTrackingInfo)

    return (
        <div className='ReactModal__Content'>
            <h1 className='transaction-status-header'>Order Tracking Information</h1>
            {/* Optional Syntax Highlighting */}
            {/* <div
                className="json-container"
                dangerouslySetInnerHTML={{ __html: syntaxHighlight(JSON.stringify(appSystemTrackData, null, 2)) }}
            /> */}
            <OrderTrackingDataGrid data={orderTrackingInfo} />

        </div>
    );
};

export default OrderTrackingPage;
